var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.171 10.2419H14.8773C12.1434 10.2419 10.5137 11.8717 10.5137 14.6055V20.8918C10.5137 23.6331 12.1434 25.2629 14.8773 25.2629H21.1635C23.8973 25.2629 25.5271 23.6331 25.5271 20.8993V14.6055C25.5346 11.8717 23.9048 10.2419 21.171 10.2419ZM18.0241 20.6665C16.4169 20.6665 15.1101 19.3597 15.1101 17.7524C15.1101 16.1452 16.4169 14.8384 18.0241 14.8384C19.6314 14.8384 20.9382 16.1452 20.9382 17.7524C20.9382 19.3597 19.6314 20.6665 18.0241 20.6665ZM22.4703 13.9071C22.4328 13.9972 22.3802 14.0798 22.3126 14.1549C22.2375 14.2225 22.1549 14.2751 22.0648 14.3126C21.9747 14.3502 21.877 14.3727 21.7794 14.3727C21.5766 14.3727 21.3888 14.2976 21.2461 14.1549C21.1785 14.0798 21.126 13.9972 21.0884 13.9071C21.0509 13.8169 21.0283 13.7193 21.0283 13.6217C21.0283 13.524 21.0509 13.4264 21.0884 13.3363C21.126 13.2386 21.1785 13.1635 21.2461 13.0884C21.4189 12.9157 21.6817 12.8331 21.9221 12.8856C21.9747 12.8931 22.0197 12.9082 22.0648 12.9307C22.1098 12.9457 22.1549 12.9682 22.2 12.9983C22.2375 13.0208 22.2751 13.0584 22.3126 13.0884C22.3802 13.1635 22.4328 13.2386 22.4703 13.3363C22.5079 13.4264 22.5304 13.524 22.5304 13.6217C22.5304 13.7193 22.5079 13.8169 22.4703 13.9071Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.0251,
    cy: 18.0251,
    r: 17.6496,
    stroke: "#5D5D5D",
    strokeWidth: 0.751047
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIg);
export default __webpack_public_path__ + "static/media/ig.52cb857bcdd88a4b038f73158dd7c01f.svg";
export { ForwardRef as ReactComponent };